export enum ProcessStatus {
  InProgress = 'InProgress',
  Finished = 'Finished',
  TimedOut = 'TimedOut',
  Idle = 'Idle',
  Canceled = 'Canceled',
  Failed = 'Failed',
  VersionCheck = 'VersionCheck'
}
